/**
 * Visibility rules for the SDMS Batch Results grid's optional columns.
 *
 * Kept as a pure, dependency-free helper (§18.4) so the rule is unit-testable
 * without rendering the 3k-line SdmsPackageDetail component.
 */

/**
 * Whether the ApprovedDate / ApprovedBy pair (grid indices 11-12) shows in the
 * SDMS Batch Results grid (client feedback 2026-08-01).
 *
 * The pair is meaningful only when the SDMS approval stage is in use — driven by
 * Default Settings › "SDMS Result Approval" (dataReviewSettings.sdmsResultApproval,
 * inlined into the login payload as permissions.dataReviewNav.sdmsResultApproval).
 * When approval is disabled there is no approval step, so the columns are always
 * empty and are hidden.
 *
 * On the SDMS Result APPROVAL form itself (`approval` mode) the pair is the point
 * of the screen and always shows, regardless of the toggle.
 *
 * @param approval           True on the SDMS Result Approval form; false on Validation.
 * @param sdmsResultApproval The Default Settings "SDMS Result Approval" toggle.
 */
export function showApprovedColumns(approval: boolean, sdmsResultApproval: boolean): boolean {
  return approval || sdmsResultApproval;
}
